import React from "react";
import styled, { css } from "styled-components";

export type IconSize = "sm" | "md" | "lg";

const SIZES: Record<IconSize, string> = {
  sm: "1.6rem",
  md: "2rem",
  lg: "2.4rem",
};

/**
 * Обёртка для иконок.
 *
 * Раньше иконки вставлялись через `<img src={...} />`. У такого способа
 * два изъяна: картинка не наследует currentColor, поэтому при наведении
 * кнопка меняла фон и цвет текста, а иконка оставалась прежней; и цвет
 * приходилось хранить в самом файле, из-за чего под каждое состояние
 * заводился отдельный файл (eyeIcon и purpleEyeIcon — один и тот же глаз).
 *
 * Здесь SVG вставляется инлайном и красится через color родителя.
 * Все файлы приведены к сетке 24x24, поэтому размер задаётся снаружи.
 */
const StyledIcon = styled.span<{ $size: IconSize }>`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  color: inherit;

  ${({ $size }) => css`
    width: ${SIZES[$size]};
    height: ${SIZES[$size]};
  `}

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

export interface IconProps {
  /** Компонент SVG: import { ReactComponent as X } from "assets/icons/x.svg" */
  glyph: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  size?: IconSize;
  /** Если иконка несёт смысл — подпись для чтения с экрана. */
  title?: string;
  className?: string;
}

export const Icon: React.FC<IconProps> = ({
  glyph: Glyph,
  size = "md",
  title,
  className,
}) => (
  <StyledIcon
    $size={size}
    className={className}
    role={title ? "img" : undefined}
    aria-label={title}
    aria-hidden={title ? undefined : true}
  >
    <Glyph />
  </StyledIcon>
);

export default Icon;
